// Session-scoped flag marking "the business-setup flow is mid-flight".
// Set just before the create-business request fires and cleared when the user
// finishes the post-create modal sequence (mode pick → preset) or logs out.
// SetupGate keeps rendering BusinessSetupPage while it is set, so the freshly
// created business appearing in the query cache doesn't swap in the app shell
// and unmount the onboarding modals mid-flow.
const KEY = "business_setup_in_progress";

export function isSetupInProgress(): boolean {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setSetupInProgress(): void {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    // Storage unavailable (private mode) — worst case the user lands on the
    // dashboard early and picks the onboarding mode via the fallback modal.
  }
}

export function clearSetupInProgress(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Storage unavailable — nothing to clear.
  }
}
